import PermissionGuard from 'components/Global/PermissionGuard';
import StatutoryComponent from 'components/Settings/PayrollSettings/StatutoryComponent';

export const StatutoryComponentPage = () => {
	return (
		<PermissionGuard permission="Allow_Statutory_Components">
			<StatutoryComponent />
		</PermissionGuard>
	);
};
